"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarousel = void 0;
var react_1 = require("react");
var useWindowSize_1 = require("../../hooks/useWindowSize");
var getPageCount = function (slideCount, slidesToScroll, slidesToShow, infinite) {
    if (slidesToScroll === void 0) { slidesToScroll = 1; }
    if (slidesToShow === void 0) { slidesToShow = 1; }
    if (infinite === void 0) { infinite = false; }
    if (infinite) {
        return Math.ceil(slideCount / slidesToScroll);
    }
    return Math.ceil((slideCount - slidesToShow) / slidesToScroll) + 1;
};
var useCarousel = function (settings) {
    var _a, _b, _c;
    var sliderRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)((settings === null || settings === void 0 ? void 0 : settings.initialSlide) || 0), activeIndex = _d[0], setActiveIndex = _d[1];
    var _e = (0, react_1.useState)(false), isAnimating = _e[0], setIsAnimating = _e[1];
    var _f = (0, react_1.useState)(0), slideCount = _f[0], setSlideCount = _f[1];
    var _g = (0, react_1.useState)(1), slidesToShow = _g[0], setSlidesToShow = _g[1];
    var size = (0, useWindowSize_1.useWindowSize)(50);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        setSlidesToShow(((_c = (_b = (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.innerSlider) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.slidesToShow) || 1);
    }, [size.width]);
    (0, react_1.useEffect)(function () { var _a, _b, _c; return setSlideCount(((_c = (_b = (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.length) || 0); }, [(_c = (_b = (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.length]);
    var pageCount = getPageCount(slideCount, settings === null || settings === void 0 ? void 0 : settings.slidesToScroll, slidesToShow, settings === null || settings === void 0 ? void 0 : settings.infinite);
    (0, react_1.useEffect)(function () {
        if (pageCount > 0 && activeIndex >= pageCount) {
            // Make sure the current page is not over the limit
            sliderRef.current.slickGoTo(pageCount - 1);
            // afterChange does not get triggered - no idea why not
            setTimeout(function () { return setIsAnimating(false); }, 100);
        }
    }, [pageCount, activeIndex]);
    return {
        activeIndex: activeIndex,
        pageCount: pageCount,
        prev: function () {
            if (isAnimating)
                return;
            sliderRef.current.slickPrev();
        },
        next: function () {
            if (isAnimating)
                return;
            sliderRef.current.slickNext();
        },
        goTo: function (index) {
            if (isAnimating)
                return;
            sliderRef.current.slickGoTo(index);
        },
        sliderRef: sliderRef,
        sliderSettings: __assign(__assign({}, settings), { beforeChange: function (oldIndex, newIndex) {
                var _a;
                setActiveIndex(newIndex);
                setIsAnimating(true);
                (_a = settings === null || settings === void 0 ? void 0 : settings.beforeChange) === null || _a === void 0 ? void 0 : _a.call(settings, oldIndex, newIndex);
            }, afterChange: function (currentIndex) {
                var _a;
                setIsAnimating(false);
                (_a = settings === null || settings === void 0 ? void 0 : settings.afterChange) === null || _a === void 0 ? void 0 : _a.call(settings, currentIndex);
            } }),
    };
};
exports.useCarousel = useCarousel;
